export default {
    WIFI_SEARCHING: 'WIFI_SEARCHING',
    LTE_SEARCHING: 'LTE_SEARCHING',
    EXPERIENCES: 'EXPERIENCES',
    OPEN_APP: 'OPEN_APP',
    PRESS_BUTTON: 'PRESS_BUTTON',
    PROGRESS_25: 'PROGRESS_25',
    PROGRESS_50: 'PROGRESS_50',
    PROGRESS_75: 'PROGRESS_75',
    PROGRESS_99: 'PROGRESS_99',
    TURNED_OFF: 'TURNED_OFF',
    TURNED_ON: 'TURNED_ON',
    IQOS_LOGO: 'IQOS_LOGO',
    USER: 'USER',
    CHECKMARK: 'CHECKMARK',
    DEFAULT: 'DEFAULT',
};
